import handleSetViewStateFailure from './handleSetViewStateFailure';
import { getContentOfSharePointTextFile } from '../../services/getContentOfSharePointTextFile';
import {
    updateFilePreviewInformation,
    getSxSViewStore,
    SharePointFileViewState,
    TextContent,
} from 'owa-group-files-hub-store';
import strings from 'owa-strings/owa-mail-strings';
import { lazySetTextPreviewState, PreviewPaneViewStateBase } from 'owa-sxsdata';

export default async function setViewStateForTextPreview(
    textContent: TextContent,
    fileViewState: SharePointFileViewState,
    optionalParameters: PreviewPaneViewStateBase
) {
    const datapoint = getSxSViewStore().datapoint; // This datapoint will end in the onLoad callbck function in FilesHubSxSLayerView
    try {
        let content;
        if (textContent != null && textContent != undefined) {
            content = textContent.Content;
        } else {
            datapoint.addCheckmark('getContentOfSharePointTextFileStart');
            content = await getContentOfSharePointTextFile(
                fileViewState.id,
                fileViewState.url,
                'PreviewInNewSxS'
            );
            datapoint.addCheckmark('getContentOfSharePointTextFileDone');
            if (content != null && content != undefined) {
                updateFilePreviewInformation(fileViewState.id, {
                    Content: content,
                    lastUpdateTime: new Date(),
                });
            }
        }

        if (content != null && content != undefined) {
            const setTextPreviewState = await lazySetTextPreviewState.import();
            await setTextPreviewState(getSxSViewStore().viewState, content, optionalParameters);
        } else {
            throw new Error('Text content is invalid');
        }
    } catch (error) {
        await handleSetViewStateFailure(error, strings.textPreviewError, datapoint);
    }
}
